/**
 * FNV-1a (32-bit) — the ONE copy of this hash in the tree (`scripts/one-impl.test.ts`
 * concern `fnv-hash`). A tiny, pure, dependency-free string hash for identity and
 * deterministic spread: a runner's display name, a deferral's jitter, a tool call's
 * signature. Not for security, and not a digest — collisions are cheap to find.
 *
 * Returns an unsigned 32-bit integer (`>>> 0`), identical on every runtime.
 */
export function fnv1a32(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i += 1) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}
